import { ResponseSchema } from 'Lib/schemas';

export const healthCheckResponseSchema = new ResponseSchema(
  {},
  {
    processResult(result) {
      return result.ok;
    },
  }
);
